// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.chart[data-v-4394deae] {\n  width: 100%;\n  height: 220px;\n}\n.chartfooter[data-v-4394deae] {\n  float: left;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
